<template>
    <div class="cascader-tree-container">
        <el-tree
            v-if="treeData && treeData.length > 0"
            ref="cascaderTree"
            :data="treeData"
            :props="defaultProps"
            :show-checkbox="isShowCheckBox"
            node-key="id"
            default-expand-all
            draggable
            :allow-drop="allowDrop"
            :expand-on-click-node="false"
            @node-click="handleNodeClick">
            <span class="cascader-tree-node" slot-scope="{ node, data }" @mouseenter="mouseenter(data)" @mouseleave="mouseleave(data)">
                <span class="node-lable">{{ node.label }}</span>
                <span class="node-button">
                    <el-tooltip class="item" effect="dark" :content="'删除当前'+ nodeName" placement="top">
                        <el-link class="removeBtn" v-show="data.opt" size="mini" type="primary" @click="remove(node, data)" icon="el-icon-delete"></el-link>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" :content="'编辑当前'+nodeName" placement="top">
                        <el-link class="editBtn" v-show="data.opt" size="mini" type="primary" @click="editLable(node, data)" icon="el-icon-edit"></el-link>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" :content="'新增下级'+nodeName" placement="top">
                        <el-link class="addBtn" v-show="data.opt" size="mini" type="primary" @click="add(node,data)" icon="el-icon-circle-plus-outline"></el-link>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" :content="'新增同级'+nodeName" placement="top">
                        <el-link class="addBtn" v-show="data.opt" size="mini" type="primary" @click="append(node,data)" icon="el-icon-plus"></el-link>
                    </el-tooltip>
                </span>
            </span>
        </el-tree>
        <el-tooltip v-else class="item" effect="dark" :content="'新增首'+nodeName" placement="top">
            <el-button class="fistAdd" type="primary" icon="el-icon-circle-plus-outline" @click="addFirst" circle></el-button>
        </el-tooltip>
    </div>
</template>

<script>
    import { getUUID } from '@/utils/grocer';
    export default {
        data () {
            return {
                clickedNode: {
                    label: ''
                },
                selectedContent: '',
                allSum: 0
            };
        },
        props: {
            treeData: { // 外部传入的树的结构数据
                type: Array,
                default: () => []
            },
            nodeName: { // node名称自定义
                type: String,
                default: '节点'
            },
            selectedNode: { // 默认选中的树节点对象
                type: Object
            },
            defaultProps: { // 默认字段名配置
                type: Object
            },
            multiple: { // 是否多选
                type: Boolean,
                default: false
            },
            isRead: {
                type: Boolean,
                default: false
            },
            isShowCheckBox: {
                type: Boolean,
                default: false
            },
            isDragforSameLevel: {// 是否只允许同级拖动
                type: Boolean,
                default: true
            },
            maxLeafCount: {// 最大叶子节点上限值
                type: Number,
                default: 60
            }
        },
        created () {
            this.init();
        },
        watch: {
            treeData (val) {
                this.getTreeFiltValSum();
            }
        },
        methods: {
            init () {
                this.getTreeFiltValSum();
            },
            allowDrop (draggingNode, dropNode, type) { // 判断是否可以被拖动
                if (this.isDragforSameLevel) {
                    if (type != 'inner' && draggingNode.level === dropNode.level && draggingNode.parent.id === dropNode.parent.id) {
                        return true;
                    } else {
                        return false;
                    }
                } else {
                    return true;
                }
            },
            handleNodeClick (data, node, comp) {
            },
            addFirst () {
                // 新增首节点
                this.$prompt('新增' + this.nodeName, '', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputPattern: /\S/,
                    inputErrorMessage: '必填',
                    beforeClose: async (action, input, done) => {
                        if (action === 'confirm') {
                            let uuid = getUUID(8, 16);
                            this.treeData.push({ id: uuid, title: input.inputValue, value: uuid, filtVal: 1 });
                            this.allSum = 1;
                            done();
                        } else {
                            done();
                        }
                    }
                }).then(async ({ value }) => {
                }).catch(() => {});
            },
            add (node, data) {
                if (data.children && data.children.length > 0 && this.getLeafCountTree(this.treeData) > this.maxLeafCount) {
                    this.$message({message: '已超过叶节点上限数' + this.maxLeafCount, type: 'warning'});
                    return false;
                }
                // 新增下级节点
                this.$prompt('新增下一级' + this.nodeName, '', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputPattern: /\S/,
                    inputErrorMessage: '必填',
                    beforeClose: async (action, input, done) => {
                        if (action === 'confirm') {
                            let uuid = getUUID(8, 16);
                            const newChild = {
                                id: uuid,
                                title: input.inputValue,
                                value: uuid,
                                filtVal: ((data.children && data.children.length > 0) ? this.getNewFiltVal(node, data) : data.filtVal)
                            };
                            if (!data.children) {
                                this.$set(data, 'children', []);
                            }
                            data.children.push(newChild);
                            if (data.children && data.children.length > 0) {
                                this.calcFiltVal(node);
                                this.getTreeFiltValSum();
                            }
                            done();
                        } else {
                            done();
                        }
                    }
                }).then(async ({ value }) => {
                }).catch(() => {});
            },
            append (node, data) {
                if (data.children && data.children.length > 0 && this.getLeafCountTree(this.treeData) > this.maxLeafCount) {
                    this.$message({message: '已超过叶节点上限数' + this.maxLeafCount, type: 'warning'});
                    return false;
                }
                // 新增同级节点
                this.$prompt('新增同级' + this.nodeName, '', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputPattern: /\S/,
                    inputErrorMessage: '必填',
                    beforeClose: async (action, input, done) => {
                        if (action === 'confirm') {
                            let uuid = getUUID(8, 16);
                            const newChild = {
                                id: uuid,
                                title: input.inputValue,
                                value: uuid,
                                filtVal: this.getNewFiltVal()
                            };
                            if (node.parent.level === 0) {
                                this.treeData.push(newChild);
                            } else {
                                if (!node.parent.data.children) {
                                    this.$set(node.parent.data, 'children', []);
                                }
                                node.parent.data.children.push(newChild);
                                this.calcFiltVal(node.parent);
                            }
                            this.getTreeFiltValSum();
                            done();
                        } else {
                            done();
                        }
                    }
                }).then(async ({ value }) => {
                }).catch(() => {});
            },
            remove (node, data) {
                // 删除节点
                const parent = node.parent;
                const filtVal = this.divideFirstBit(data.filtVal);
                const children = parent.data.children || parent.data;
                const index = children.findIndex(d => d.id === data.id);
                children.splice(index, 1);
                this.calcFiltVal(parent, filtVal);
                this.getTreeFiltValSum();
            },
            mouseenter (data) {
                this.$set(data, 'opt', true);
            },
            mouseleave (data) {
                this.$set(data, 'opt', false);
            },
            editLable (node, data) {
                // 编辑节点
                this.$prompt('编辑' + this.nodeName, '', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputPattern: /\S/,
                    inputValue: data.label,
                    inputErrorMessage: '必填',
                    beforeClose: async (action, input, done) => {
                        if (action === 'confirm') {
                            data.title = input.inputValue;
                            done();
                        } else {
                            done();
                        }
                    }
                }).then(async ({ value }) => {
                }).catch(() => {});
            },
            getTreeFiltValSum () {
                // 计算出当前所有节点的过滤值总和
                if (this.treeData && this.treeData.length > 0) {
                    this.allSum = 0;
                    this.treeData.forEach(d => {
                        this.allSum = this.allSum | d.filtVal;
                    });
                }
            },
            calcFiltVal (node, sonFiltVal) {
                // 计算当前节点及其父节点的filtVal值
                if (node.data.children && node.data.children.length > 0) {
                    let filtVal = 0;
                    node.data.children.forEach(child => {
                        filtVal = filtVal | child.filtVal;
                    });
                    node.data.filtVal = filtVal;
                } else {
                    node.data.filtVal = sonFiltVal;
                }
                if (node.parent && node.parent.level !== 0) {
                    this.calcFiltVal(node.parent, sonFiltVal);
                }
            },
            getNewFiltVal () {
                let newVal = 0;
                if (this.allSum) {
                    if (Math.floor(Math.log2(Number(this.allSum))) < 33) {
                        // 如果2的幂次取值在32以内，先使用后面的值
                        newVal = Math.pow(2, (Math.floor(Math.log2(Number(this.allSum))) + 1));
                    } else {
                        let valStr = Number(this.allSum).toString(2).split('').reverse().join('');
                        if (valStr.indexOf('0') > -1) {
                            // 找到前面尚未使用的值
                            for (var i = 0; i < valStr.length; i++) {
                                if (valStr.charAt(i) === '0') {
                                    newVal = Math.pow(2, i);
                                    break;
                                }
                            }
                        } else {
                            // 取后一个2的幂次值
                            newVal = Math.pow(2, (Math.floor(Math.log2(Number(this.allSum))) + 1));
                        }
                    }
                }
                return newVal;
            },
            divideFirstBit (num) {
                let first = 0;
                if (num) {
                    let valStr = Number(num).toString(2).split('').reverse().join('');
                    for (var i = 0; i < valStr.length; i++) {
                        if (valStr.charAt(i) === '1') {
                            first = Math.pow(2, i);
                            break;
                        }
                    }
                }
                return first;
            },
            getLeafCountTree (json) {
                if (!json.children || json.children.length === 0) {
                    json.colspan = 1;
                    return 1;
                } else {
                    var leafCount = 0;
                    for (var i = 0; i < json.children.length; i++) {
                        leafCount = leafCount + this.getLeafCountTree(json.children[i]);
                    }
                    json.colspan = leafCount;
                    return leafCount;
                }
            }
        }
    };
</script>
<style lang="less">
    .cascader-tree-container{
        .cascader-tree-node {
            align-items: center;
            justify-content: space-between;
            font-size: 14px;
            padding-right: 8px;
            .node-button{
                margin-left:8px;
                .el-link{
                    margin-top:2px;
                }
                .removeBtn{
                    float:right;
                }
                .editBtn{
                    margin-right: 10px;
                    float:right;
                }
                .addBtn{
                    margin-right: 10px;
                    float:right;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/FieldProps/CascaderTree.vue